import React, { useState, useEffect } from 'react';
import { FormCheck, FormLabel } from 'react-bootstrap';
import useLocalization from '../../hooks/useLocalization';

const MultiCheckboxInput = ({
  options,
  value,
  onChange,
  checkBoxContainerClassName,
  labelClassName,
  containerStyle,
  checkboxStyle = {
    width: 20,
    height: 20,
    fontSize: 20,
    marginBottom: 8
  },
  size = 'sm'
}) => {
  const { translate, isRTL } = useLocalization();
  const [checkedOptions, setCheckedOptions] = useState([]);

  const handleCheckboxChange = optionValue => {
    const newCheckedOptions = checkedOptions.includes(optionValue)
      ? checkedOptions.filter(value => value !== optionValue)
      : [...checkedOptions, optionValue];
    setCheckedOptions(newCheckedOptions);
    onChange(newCheckedOptions);
  };

  useEffect(() => {
    setCheckedOptions(value || []);
  }, [value]);

  return (
    <div style={containerStyle} className={`d-flex flex-wrap gap-3 ${checkBoxContainerClassName}`}>
      {options.map(option => (
        <div key={option.value} className={`d-flex align-items-center gap-1`}>
          <FormCheck
            id={option.value}
            reverse={isRTL}
            type="checkbox"
            checked={checkedOptions.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
            size={size}
            style={checkboxStyle}
          />
          <FormLabel className={`m-0 ${labelClassName}`} htmlFor={option.value}>
            {translate(option.label) || option.value}
          </FormLabel>
        </div>
      ))}
    </div>
  );
};
export default MultiCheckboxInput;
